import {useMutation, useQuery, useQueryClient, UseQueryResult} from "react-query";
import {
    addActe,
    changeOrdreActe, fetchActeAbsences, fetchActesHorairesByIDActe, fetchAllCetPocket,
    getActeById,
    getAllActes, getAllActesAbsence,
    modifyActe, putActeHoraires,
    switchActeMaster,
    TrashActe
} from "./acte.services";
import {toast} from "react-toastify";

export const useGetAllActes = (idCentre:number|null=null):UseQueryResult<Acte[], Error>=>{
    const queryClient = useQueryClient();
    if(!idCentre) {
        const userConnected: User | undefined = queryClient.getQueryData(["user_connected"]);
        idCentre = userConnected ? userConnected.Centre.id : 0;
    }
    return useQuery<Acte[], Error>(["actes", idCentre], ()=>getAllActes(idCentre||0), {
        staleTime:50000*10,
        cacheTime:60000*10,
        enabled:idCentre!== null && idCentre!==0
    })
}

export const useGetHorairesByActe = (id:number):UseQueryResult<ActeHoraire[], Error>=>{
    return useQuery(["acte_horaires", id], ()=>fetchActesHorairesByIDActe(id), {
        enabled:id!==0
    })
}
export const useAllActeAbsence = ():UseQueryResult<Acte[], Error>=>{
    return useQuery(["actes_absences"], fetchActeAbsences)
}
export const useGetAllActesAbs = ():UseQueryResult<Acte[], Error>=>{
    return useQuery(["actes_dem_absences"], getAllActesAbsence)
}

export const useGetActeById = (id:number):UseQueryResult<Acte, Error>=>{
    return useQuery<Acte, Error>(["acte", id], ()=>getActeById(id), {
        enabled:id!==0
    })
}

export const useGetAllActeCetPocket = ():UseQueryResult<ActeCetPocket[], Error>=>{
    return useQuery(["acte_cet_pocket"], ()=>fetchAllCetPocket())
}

export const useModifyActe = ()=>{
    const queryClient = useQueryClient();
    return useMutation(
        (data:{id:number, datas: ActeFD})=>{
            return modifyActe(data.id, data.datas);
        }, {
            onSuccess:()=>{
                queryClient.invalidateQueries(["actes"]);
            }, onError:()=>{
                toast.error("impossible de modifier l'acte")
            }
        }
    )
}

export const useAddActe = ()=>{
    const queryClient = useQueryClient();
    return useMutation(
        (datas:ActeFD)=>{
            return addActe(datas);
        }, {
            onSuccess:()=>{
                queryClient.invalidateQueries(["actes"]);
                toast.success("Acte créé")
            }, onError:()=>{
                toast.error("impossible de créer acte")
            }
        }
    )
}

export const useChangeOrdreActe = ()=>{
    const queryClient = useQueryClient();
    return useMutation(
        (data:ActesChangeOrdre)=>{
            return changeOrdreActe(data);
        }, {
            onSuccess:()=>{
                queryClient.invalidateQueries(["actes"]);
            },
            onError:()=>{
                toast.error("Une erreur est survenue merci de retenter plus tard")
            }
        }
    )
}

export const useSwitchActeMaster = ()=>{
    const queryClient = useQueryClient();
    return useMutation(
        (id:number)=>{
            return switchActeMaster(id);
        }, {
            onSuccess:()=>{
                queryClient.invalidateQueries(["actes"]);
            },
            onError:()=>{
                toast.error("Une erreur est survenue merci de retenter plus tard")
            }
        }
    )
}

export const useTrashActe = ()=>{
    const queryClient = useQueryClient();
    return useMutation(
        (id:number)=>{
            return TrashActe(id);
        }, {
            onSuccess:()=>{
                queryClient.invalidateQueries(["actes"]);
            },
            onError:()=>{
                toast.error("Une erreur est survenue merci de retenter plus tard")
            }
        }
    )
}

export const usePutActeHoraires = ()=>{
    const queryClient = useQueryClient();
    return useMutation(
        (datas:ActeHoraireFD)=>{
            return putActeHoraires(datas)
        }, {
            onSuccess:()=>{
                queryClient.invalidateQueries(["actes"])
            }
        }
    )
}
